import Image from "next/image";
import * as Info from "./info";
import useTranslations from "@/i18n/useTranslations";

export default function ProgramContentBlock() {
  const t = useTranslations("Homepage");
  const tCommon = useTranslations("Common");
  return (
    <div className="container my-9 pb-20">
      <div className="flex flex-col lg:grid lg:grid-cols-2">
        <div>
          <p className="text-base mb-3">
            {t("aboutEdxIntroBefore")}{" "}
            <strong>{t("aboutEdxIntroBold")}.</strong>
          </p>
          <div className="flex flex-col md:grid md:grid-cols-2 gap-4">
            <div>
              <div className="mt-0 mb-2 text-xl font-bold">
                {t("aboutEdxPropelling")}
              </div>
              <p className="m-0">{t("aboutEdxPropellingDesc")}</p>
            </div>
            <div>
              <div className="mt-0 mb-2 text-xl font-bold">
                {t("aboutEdxConvenient")}
              </div>
              <p className="m-0">{t("aboutEdxConvenientDesc")}</p>
            </div>
            <div>
              <div className="mt-0 mb-2 text-xl font-bold">
                {t("aboutEdxFlexible")}
              </div>
              <p className="m-0">{t("aboutEdxFlexibleDesc")}</p>
            </div>
            <div>
              <div className="mt-0 mb-2 text-xl font-bold">
                {t("aboutEdxSupportive")}
              </div>
              <p className="m-0">{t("aboutEdxSupportiveDesc")}</p>
            </div>
          </div>
        </div>
        <div className="hidden lg:flex justify-center items-center">
          <Image
            src={Info.image}
            alt={tCommon("globalEducationAlt")}
            width={400}
            height={312}
          />
        </div>
      </div>
    </div>
  );
}
